import { render } from "./DynamicButton.vue?vue&type=template&id=72c9ffe6"
import script from "./DynamicButton.vue?vue&type=script&lang=js"
export * from "./DynamicButton.vue?vue&type=script&lang=js"

import "./DynamicButton.vue?vue&type=style&index=0&id=72c9ffe6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__